// extracted by mini-css-extract-plugin
export default {"currency":"currency-formatter_currency__UAbMJ"};